import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-cobalt/[0.06] px-5 py-6 sm:py-12" data-id="element-39" data-mp="qtt8yusij3by">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="qsi56uz2hvku">
        <div className="mx-auto max-w-2xl text-center" data-id="element-41" data-mp="14t2kvi9orba4">
          <h2 className="font-serif-display text-xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-42" data-mp="14rhqptra9ucs">
            🎁 4 BONUS PROFESSIONALI INCLUSI OGGI
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-43" data-mp="1eicex3o3b40v">
            Nessun costo aggiuntivo. Li ricevi insieme ai cinque volumi.
          </p>
        </div>

        <div className="mt-6 grid gap-4 sm:mt-10 sm:gap-6 md:grid-cols-2" data-id="element-44" data-mp="1njkc1ievdytd">
          {bonuses.map((bonus, i) => {
          const isOpen = openIndex === i;
          return <motion.article key={bonus.badge} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.4,
            delay: i % 2 * 0.08
          }} className="flex flex-col rounded-2xl border border-cobalt/25 bg-white p-5 shadow-sm shadow-cobalt/5 sm:p-7" data-id="element-45" data-mp="3pqbrz8csaqzj" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-46" data-mp="ckld8icwe46g">
                  <span className="rounded-md bg-cobalt px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-47" data-mp="chz6gkxtzspa">
                    {bonus.badge}
                  </span>
                  <span className="text-2xl" aria-hidden="true" data-id="element-48" data-mp="lcvps6b9mlqv">
                    {bonus.icon}
                  </span>
                </div>
                <h3 className="mt-4 text-sm font-bold leading-snug text-ink sm:text-lg" data-id="element-49" data-mp="vajmh1sfm3bo">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[13px] font-medium leading-snug text-cobalt-deep sm:text-sm" data-id="element-50" data-mp="109w7ri3nn2c5">
                  {bonus.subtitle}
                </p>
                <div className="mt-3 flex items-center justify-between" data-id="element-51" data-mp="5me3fub344t5">
                  <span className="inline-block rounded-full bg-cobalt/10 px-2.5 py-1 text-[11px] font-medium text-cobalt-deep sm:text-xs" data-id="element-52" data-mp="5kb58mzs35dc">
                    {bonus.pages} · Incluso
                  </span>
                </div>

                <div className="mt-4 border-t border-cobalt/10 pt-3 sm:hidden" data-id="element-53" data-mp="tb74g56kd2um">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between text-xs font-bold text-ink/70" data-id="element-54" data-mp="ocnii4ryzr29">
                    Scopri cosa contiene
                    <ChevronDownIcon className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-55" data-mp="3519gpt2sxcso" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-56" data-mp="3049bfkds0e2m">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-57" data-mp="1fkxg1jzj3vhm">
                        <p className="pt-3 text-[13px] leading-relaxed text-ink/70" data-id="element-58" data-mp="wsl3y5j2pfua">
                          {bonus.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <p className="mt-4 hidden flex-1 text-sm leading-relaxed text-ink/70 sm:block" data-id="element-59" data-mp="rub77qhpa76k">
                  {bonus.description}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}